import React from 'react';

const Video = ({
  modifier = '',
  video,
  sources,
  autoPlay = true,
  loop = true,
  muted = true,
}) => {
  const videoPath = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `/videos/aaron-king/`
    : `/videos/`;

  return (
    <div className={`c-app-video ${modifier}`}>
      <video
        className="c-app-video__item"
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        title={video}
      >
        {sources
          ? sources.map((src, index) => {
              return (
                <source
                  key={`video-source-${index}`}
                  src={`${__ENVIRONMENT_CONFIG__.PUBLIC_URL}${videoPath}${video}.${src}`}
                  type={`video/${src}`}
                />
              );
            })
          : null}
      </video>
    </div>
  );
};

export default Video;
